import { createAction } from "@reduxjs/toolkit";

import { ActiveResouces } from "../../types";

const ACTION_PREFIX = "SET_RESOURCES";

export const setActiveResources = createAction<ActiveResouces>(`${ACTION_PREFIX}/SET`);
